/* eslint-disable vue/html-indent */
<template>
  

  <!--Begin mobile nav -->
    <ul
        id="mobile-nav"
        v-cloak
        class="sidenav"
    >
        <li>
            <img
            v-cloak
            title="Eco Web Hosting logo"
            alt="Eco Web Hosting logo"
            src="@/assets/images/logo.svg"
        > 

        <span
            v-cloak
            class="tagline"
        >Web Hosting
        </span>
        </li>

         <li class="phone">Call Sales: <span class="phone-no"><a href="tel:03300430712">0330 912 1269</a></span></li>  
            <li class="account-basket">
                <router-link to="/account" >
                    <i class="left"><img
                        v-cloak
                        src="@/assets/images/account.svg"
                        alt=" "
                    ></i><span class="hide-text">Account</span>
                </router-link>
            </li>
            <li class="account-basket">
                <router-link to="/basket">
                    <i class="left"><img
                        v-cloak
                        src="@/assets/images/basket.svg"
                        alt=" "
                    ></i><span class="hide-text">Basket</span>
                </router-link>
            </li>
        
        <li>
            <router-link to="/web-hosting" class="product wh-tm-pl sidenav-close">
                 <img
                    v-cloak
                    src="@/assets/images/nav/nav-web-hosting-icon.svg"
                    alt="Web Hosting"
                >
                <h3>Web Hosting</h3>
                <p>Simple, fast, and reliable fully-featured web hosting packages.</p>
            </router-link>
        </li>
        <li>
            <router-link to="/reseller-hosting" class="product sidenav-close">
               <img
                    v-cloak
                    src="@/assets/images/nav/nav-reseller-icon.svg"
                    alt="Reseller Hosting"
                >
                <h3>Reseller Hosting</h3>
                <p>Build your business on our platform with no additional fees.</p>
            </router-link>
        </li>
        <li>
            <router-link to="/managed-wordpress" class="product mwp-tm-pl sidenav-close">
                <img
                    v-cloak
                    src="@/assets/images/nav/nav-wordpress-icon.svg"
                    alt="Managed WordPress Hosting"
                >
                <h3>Managed WordPress Hosting</h3>
                <p>Ultra-fast hosting for the most popular CMS in the world.</p>
            </router-link>
        </li>

         <li>
            <router-link to="vps" class="product vps-tm-pl sidenav-close">
                  <img
                        v-cloak
                        src="@/assets/images/nav/nav-vps-icon.svg"
                        alt="Virtual Private Servers"
                    >
                    <h3>VPS</h3>
                    <p>Customisable and fast virtual private servers built for business.</p>
            </router-link>
        </li>


        <li>
            <router-link to="/domain-names" class="dn-tm-pl sidenav-close">
                Domain Names
            </router-link>
        </li>
       
        <li>
            <router-link to="/about" class="abt-tm-pl sidenav-close">
                About Us
            </router-link>
        </li>
        <li>
            <router-link to="/support" class="st-tm-pl sidenav-close">
                Support
            </router-link>
        </li>
        <li> 
            <router-link to="/contact" class="ct-tm-pl sidenav-close">
                Contact
            </router-link>
        </li>
         <li> 
            <router-link to="/green-credentials" class="ct-tm-pl sidenav-close">
                <span class="green-creds">Green creds</span>
            </router-link>
        </li>
    </ul>
    <!-- End mobile nav -->
</template>

<script>
export default {
  name: "MobileNav",
};
</script>

<style lang="scss" scoped>
#overlay {
  height: 100vh;
  width: 100vw;
  background: #ec6451;
  z-index: 2;
  visibility: hidden;
  position: fixed;
  &.active {
    visibility: visible;
  }
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    height: 100vh;
    padding-left: 0;
    list-style-type: none;
    li {
      padding: 1em;
      a {
        color: white;
        text-decoration: none;
        font-size: 1.5em;
        &:hover {
          color: #333332;
        }
      }
    }
  }
}






.phone {
  display: block;
  clear: both;
  position: relative;
  top: 0px;
  line-height: 25px;
  float: left;
  height: 33px;
  font-size: 14px;
  padding-left: 40px;
  margin-top: 10px;
  margin-bottom: -8px;

  .phone-no {
    font-size: 20px;
  }

  .phone-no,
  .phone-no a {
    font-size: 20px;
    font-weight: bold;
    color: #247975;
    padding-left: 3px;
    height: auto;
    border-radius: 0px;
    margin-left: 0px;
    background: transparent;
    display: inline;

    &:hover {
      color: #247975;
      background-color: transparent !important;
    }
  }
}

ul {
  h3 {
    font-size: 14px;
    margin-bottom: 0px;
  }

  p {
    font-size: 12px;
    margin-block-start: 0px;
    margin-block-end: 0px;
  }

  li {
    &:last-child {
      border-bottom: 0px;
    }

    a {
      font-size: 12px;
    }

    .product {
      height: auto;
      padding: 12px 20px 44px;

      img {
        float: left;
        margin-right: 10px;
        margin-top: 4px;
        width: 40px;
        margin-left: 0px;
      }

      p {
        text-align: left;
        line-height: normal;
        position: absolute;
        margin-left: 50px;
        padding-right: 20px;
        font-family: "Lato", sans-serif;
      }
    }
  }

  .nav-web-hosting {
    &:hover {
      background-color: #d2dcd4 !important;
    }
  }

  .nav-wordpress {
    &:hover {
      background-color: #cbdae5 !important;
    }
  }

  .nav-vps {
    &:hover {
      background-color: #d5d5e9 !important;
    }
  }

  .nav-reseller {
    &:hover {
      background-color: #f1dbde !important;
    }
  }

  .tagline {
    position: absolute;
    top: 11px;
    left: 136px;
  }

  .green-creds {
    color: green;
  }
}
#mobile-nav {
  @media (min-width: 1045px) {
    display: none;
  }
}
</style>